import { subtitlePicks } from "@/mocks/home";

export default function SubtitleZone() {
  return (
    <section id="subtitle" className="border-b border-background-200/70 bg-secondary-950">
      <div className="flex flex-col gap-10 px-4 py-12 md:px-10 md:py-16 lg:flex-row lg:gap-14">
        <div className="w-full lg:w-2/5">
          <div className="flex items-center gap-2 text-xs font-medium uppercase tracking-widest text-accent-400">
            <i className="ri-closed-captioning-line text-base"></i>
            SUBTITLE ZONE
          </div>
          <h2 className="mt-3 font-heading text-2xl font-semibold text-background-50 md:text-3xl">
            中文字幕专区
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-background-200">
            每个版本都以中文字幕为基础整理：精校版重排时间轴，双语版适合对照原文，听障友好版额外标注环境音。
            挑选符合你习惯的字幕版本，剧情理解会更顺畅。
          </p>

          <div className="mt-7 space-y-3">
            {[
              { icon: "ri-text", label: "逐句校对时间轴，长句拆分为易读两行" },
              { icon: "ri-translate-2", label: "中英对照排列，兼顾理解与原文" },
              { icon: "ri-volume-mute-line", label: "标注环境音与情绪提示，覆盖更多观众" },
            ].map((row) => (
              <div
                key={row.label}
                className="flex items-start gap-3 rounded-lg border border-background-50/10 bg-background-50/5 px-4 py-3.5"
              >
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-accent-500 text-accent-950">
                  <i className={`${row.icon} text-base`}></i>
                </span>
                <span className="text-sm leading-relaxed text-background-100">{row.label}</span>
              </div>
            ))}
          </div>

          <a
            href="#movies"
            className="mt-7 flex w-fit cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-5 py-3 text-sm font-medium text-accent-950 transition-colors hover:bg-accent-400"
          >
            <i className="ri-play-list-line text-base"></i>
            进入字幕版本列表
          </a>
        </div>

        <div className="w-full lg:w-3/5">
          <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
            {subtitlePicks.map((item) => (
              <article
                key={item.id}
                className="group flex gap-4 rounded-lg border border-background-50/10 bg-background-50/5 p-3 transition-colors hover:border-accent-500/50"
              >
                <div className="h-28 w-24 shrink-0 overflow-hidden rounded-md">
                  <img
                    src={item.cover}
                    alt={`${item.title} 中文字幕版本`}
                    title={`${item.title} 中文字幕`}
                    className="h-full w-full object-cover object-top"
                  />
                </div>
                <div className="flex min-w-0 flex-1 flex-col">
                  <h3 className="font-heading text-sm font-semibold text-background-50">
                    {item.title}
                  </h3>
                  <p className="mt-1.5 line-clamp-2 text-xs leading-relaxed text-background-300">
                    {item.desc}
                  </p>
                  <div className="mt-2 flex flex-wrap gap-1.5">
                    {item.tags.map((tag) => (
                      <span
                        key={tag}
                        className="rounded-full bg-accent-500/15 px-2 py-0.5 text-[11px] text-accent-300"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                  <div className="mt-auto flex items-center justify-between pt-3">
                    <span className="text-xs text-background-300">{item.duration}</span>
                    <span className="flex cursor-pointer items-center gap-1 whitespace-nowrap text-xs font-medium text-accent-400">
                      <i className="ri-play-circle-line text-base"></i>
                      观看
                    </span>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}